import { terms } from "..";
import { COLOR_PRIMARY_GREEN, COLOR_SECONDARY_GREEN, COLOR_TERTIARY_GREEN } from "../../../common/constants/colors";

const LOW_HEX_COLOR = COLOR_PRIMARY_GREEN;
const HIGH_HEX_COLOR = COLOR_SECONDARY_GREEN;
const AUX_HEX_COLOR = COLOR_TERTIARY_GREEN;

export const overviewStatusKeys = {
    currentTab: 'currentTab',
    chartSettings: 'chartSettings',
    activity: 'activity',
    inventory: 'inventory',
    prices: 'prices',
};

export const tabIndex = {
    inventory: 0,
    prices: 1,
    activity: 2,
};

export const tabNames = {
    activity: 'Activity',
    inventory: 'Inventory',
    prices: 'Prices',
};

const listingOption = {
    overview: 'overview',
};

export const listingOptions = {
    overview: {label: terms.overview, value: listingOption.overview},
};

export const listingIds = {
    Last13Months: 'monthlySupplyOfInventory',
    Last25Months: 'monthlySupplyOfInventory',
    Last13Quarters: 'avgDomCdom',
    Last24Weeks: 'underContractUc'
};

export const chartLegends = {
    forSale: 'FOR SALE',
    fortyFiveDaysOrLess: '45 DAYS OR LESS',
    fourMonthsOrLess: '4 MONTHS OR LESS',
    medianList: 'MEDIAN (LIST)',
    medianSold: 'MEDIAN (SOLD)',
    moreThanFourMonths: 'MORE THAN 4 MONTHS',
    moreThanFortyFiveDays: 'MORE THAN 45 DAYS',
    sold: 'SOLD',
    underContract: 'UNDER CONTRACT',
};

export const optionLabels = {
    forSale: 'For Sale',
    sold: 'Sold',
}

export const labels = {
    medianList: 'Median (List)',
    medianSold: 'Median (Sold)',
};

const overviewGroup = {
    averageDom: 'averageDom'
};

export const overviewPeriods = {
    monthly: {
        value: 'monthly',
        lowHexColor: LOW_HEX_COLOR,
        highHexColor: HIGH_HEX_COLOR,
        auxHexColor: AUX_HEX_COLOR,
        statusGroup: terms.monthsSupply,
        threshold: 4,
        xAxisLegends: [chartLegends.fourMonthsOrLess, chartLegends.moreThanFourMonths],
        yAxisText: terms.monthsSupply,
    },
    other: {
        value: 'other',
        lowHexColor: LOW_HEX_COLOR,
        highHexColor: HIGH_HEX_COLOR,
        auxHexColor: AUX_HEX_COLOR,
        statusGroup: overviewGroup.averageDom,
        threshold: 45,
        xAxisLegends: [chartLegends.fortyFiveDaysOrLess, chartLegends.moreThanFortyFiveDays],
        yAxisText: terms.avgDom,
    }
};
